export function quillHtmlToPlainText(html: string): string {
    if (typeof document === 'undefined') {
        return `${html ?? ''}`.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    }

    const div = document.createElement('div');
    div.innerHTML = `${html ?? ''}`;
    return (div.textContent || '').replace(/\s+/g, ' ').trim();
}

export function isQuillHtmlEmpty(html: string): boolean {
    return !quillHtmlToPlainText(html);
}
